import { useEffect } from "react";
import Footer from "components/footer/FooterAuthDefault";
import NotFound from "../../views/public/NotFound";
import { Routes, Route, Navigate } from "react-router-dom";
import useRoutes from "routes";

const theme = process.env.REACT_APP_THEME || "default";

export default function Auth() {
  const { routes } = useRoutes(null);
  const authRoutes = routes.auth;

  useEffect(() => {
    const updateFavicon = (newFavicon: string, newFavicon32: string, newFavicon16: string, newFavicon180: string) => {
      const icon = document.querySelector('link[data-favicon-ico]') as HTMLLinkElement;
      const icon32 = document.querySelector('link[rel="icon"][sizes="32x32"]') as HTMLLinkElement;
      const icon16 = document.querySelector('link[rel="icon"][sizes="16x16"]') as HTMLLinkElement;
      const icon180 = document.querySelector('link[rel="apple-touch-icon"][sizes="180x180"]') as HTMLLinkElement;

      if (icon) {
        icon.href = "";
      }

      if (icon32) {
        icon32.href = "";
      }

      if (icon16) {
        icon16.href = "";
      }

      if (icon180) {
        icon180.href = "";
      }

      icon.href = `${newFavicon}?t=${new Date().getTime()}`;
      icon32.href = `${newFavicon32}?t=${new Date().getTime()}`;
      icon16.href = `${newFavicon16}?t=${new Date().getTime()}`;
      icon180.href = `${newFavicon180}?t=${new Date().getTime()}`;
    };

    updateFavicon(`/themes/${theme}/favicon.ico`, `/themes/${theme}/favicon-32x32.png`, `/themes/${theme}/favicon-16x16.png`, `/themes/${theme}/favicon-180x180.png`);

    const manifest = document.querySelector("link[rel='manifest']");
    if (manifest) manifest.setAttribute("href", `/themes/${theme}/site.webmanifest`);
  }, []);

  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";

  return (
    <div>
      <div className="relative h-auto min-h-screen w-full">
        <main className={`mx-auto min-h-screen`}>
          <div className="relative flex items-center justify-center">
            <div className="mx-auto flex flex-col pt-12 lg:h-screen lg:px-8 lg:pt-0 xl:h-full xl:min-h-screen xl:px-0">
              <div className="mb-auto flex flex-col items-center justify-center md:pr-0 lg:pl-0 xl:max-w-full">
                <Routes>
                  {getRoutes(authRoutes)}
                  <Route
                    path="/"
                    element={<Navigate to="/auth/sign-in" replace />}
                  />
                  <Route path="*" element={<NotFound hideFooter={true} />} />
                </Routes>
              </div>
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
